import { useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { CustomTabs, TableCard, TabItem } from '../../../components'
import { RelatoriosListSearchComponent } from './components/header/RelatoriosListSearchComponent'
import { RelatoriosListToolbar } from './components/header/RelatoriosListToolbar'
import { AbaRelatorio } from './core/_models'
import { ListFiltersProvider, useParametrosRelatorios } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { SecaoIndicadores } from './secoes/SecaoIndicadores'
import { RelatorioMensalTable } from './table/RelatorioMensalTable'
import { QuantitativoTable } from './table/QuantitativoTable'
import { RatcTable } from './table/RatcTable'

const ABAS: TabItem<AbaRelatorio>[] = [
  { id: 'indicadores', label: 'Indicadores' },
  { id: 'quantitativo', label: 'Quantitativo' },
  { id: 'ratc', label: 'RATC' },
  { id: 'mensal', label: 'Mensal' },
]

/** RATC com paginação do backend; `key` pelo filtro volta para a primeira página quando ele muda. */
const RatcWrapper = () => {
  const { periodo } = useParametrosRelatorios()
  return (
    <QueryRequestProvider key={JSON.stringify(periodo ?? null)}>
      <QueryResponseProvider>
        <RatcTable />
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

/**
 * Relatórios regulatórios da interconsulta (Anexo IV do edital da Secretaria de Saúde). Um card com a
 * barra de filtros (contexto de filtros compartilhado) acima das abas; cada aba busca o próprio
 * relatório. Gate: `Atendimento:indicadores`.
 */
const RelatoriosInterconsulta = () => {
  const [aba, setAba] = useState<AbaRelatorio>('indicadores')

  return (
    <TableCard>
      <div className='card-header border-0 pt-6'>
        <RelatoriosListSearchComponent aba={aba} actions={<RelatoriosListToolbar aba={aba} />} />
      </div>
      <div className='px-9'>
        <CustomTabs<AbaRelatorio>
          tabs={ABAS}
          activeTab={aba}
          onChange={setAba}
          className='mb-2 nav-line-tabs-2x'
          tabClassName='fs-5 fw-semibold text-gray-700'
          activeTabClassName='text-gray-900 fw-bolder'
        />
      </div>
      {aba === 'indicadores' && <SecaoIndicadores />}
      {aba === 'quantitativo' && <QuantitativoTable />}
      {aba === 'ratc' && <RatcWrapper />}
      {aba === 'mensal' && <RelatorioMensalTable />}
    </TableCard>
  )
}

const InterconsultaRelatoriosPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.relatorios_interconsulta.descricao')}>
              {t('menu.relatorios_interconsulta')}
            </PageTitle>
            <ListFiltersProvider>
              <RelatoriosInterconsulta />
            </ListFiltersProvider>
          </>
        }
      />
    </Routes>
  )
}

export default InterconsultaRelatoriosPage
